<script setup>
import { toRefs } from 'vue';

import Image from 'primevue/image';

import useSpacing from '@/composables/useSpacing';

const props = defineProps(['settings']);
const { settings } = toRefs(props);

const { padding } = useSpacing(settings);
</script>
<template>
  <div class="element image-element">
    <Image
      class="image"
      imageClass="image__image"
      :src="settings?.src"
      :alt="settings?.alt ?? ' '"
      :width="`${settings?.width}%`"
      :data-test="`pages-image-${settings?.src}`"
    />
  </div>
</template>

<style scoped lang="scss">
.image-element {
  display: flex;
  justify-content: center;
  padding: v-bind(padding);
}

.image {
  & :deep(.image__image) {
    margin: 0 auto;
  }
}
</style>
